import React from "react";
import styles from "./SnackBarCustom.module.scss";

export default function SnackBarCustom(snackBarCustomProps) {
  const {
    isOpen,
    title,
    description,
    iconButton,
    backgroundColor,
    textColor,
    handleAction,
  } = snackBarCustomProps;

  const customStyles = {
    backgroundColor: backgroundColor ?? "#213448",
    textColor: textColor ?? "#FFF",
  };

  return (
    <div onClick={handleAction} className={styles.snackbarWrapper}>
      <div
        className={isOpen ? styles.snackbar : styles.slideOut}
        style={customStyles}
      >
        <div className={styles.snackbarContent}>
          {iconButton}
          <div className={styles.textContent}>
            <span className={styles.titleWrapper}>{title}</span>
            <span className={styles.descriptionWrapper}>{description}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
